exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".style__jewelryFilters___3ZiDP{position:relative}.style__jewelryFilters___3ZiDP h4{font-size:16px;font-family:PlayfairDisplay-Regular;letter-spacing:1px;font-weight:400;color:#000;margin:7px 0}", ""]);

// exports
exports.locals = {
	"jewelryFilters": "style__jewelryFilters___3ZiDP"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules&localIdentName=[name]__[local]___[hash:base64:5]!./src/components/jewelry-search-filters/style.css
// module id = 695
// module chunks = 0